export const enum CoursesRouteNames {
    ALL_COURSES_OVERVIEW = 'all_courses_overview',
    COURSES_DASHBOARD = 'course_dashboard',
    COURSE_OVERVIEW = 'course_overview',
    COURSE_PLAYER = 'course_player',
    COURSE_SCORM_PLAYER = 'course_scorm_player',
    PLAYLIST_OVERVIEW = 'playlist_overview',
}
